import { render, staticRenderFns } from "./ProductsFilter.html?vue&type=template&id=66cc91e0&scoped=true&"
import script from "./ProductsFilter.component.js?vue&type=script&lang=js&"
export * from "./ProductsFilter.component.js?vue&type=script&lang=js&"
import style0 from "./ProductsFilter.scss?vue&type=style&index=0&id=66cc91e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc91e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VProgressCircular,VSpacer})
